import React from 'react';

import { Skeleton } from '@material-ui/lab';

import BaseSkeleton from '../BaseSkeleton';
import Card from '../../../Card';

import { SummaryProgressCardSkeletonProps } from './SummaryProgressCardSkeleton.types';

const SummaryProgressCardSkeleton: React.FC<SummaryProgressCardSkeletonProps> = ({ className }) => {
  return (

      <Card className={`relative flex flex-justify p4 ${className}`}>
        <div className='flex flex-column'>
          <div className='flex flex-column mb4'>
            <BaseSkeleton width={120} height={30}  />
            <BaseSkeleton width={90} height={30} />
          </div>
          <div className='flex flex-column mb2'>
            <BaseSkeleton width={120} height={30} />
            <BaseSkeleton width={90} height={30} />
          </div>
        </div>
        <div className='flex'>
          <Skeleton variant='circle' width={110} height={110} className="my2" />
        </div>
      </Card>

  );
};

export default SummaryProgressCardSkeleton;
export { SummaryProgressCardSkeletonProps };